<template>
  <span
    :class="['app-badge', `badge-${variant}`, { 'badge-pill': pill, 'badge-outline': outline }]"
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
defineProps({
  outline: {
    default: false,
    type: Boolean,
  },
  pill: {
    default: false,
    type: Boolean,
  },
  variant: {
    default: 'muted',
    type: String,
    validator: (v: string) =>
      ['accent', 'success', 'danger', 'warning', 'muted', 'on-call', 'travel'].includes(v),
  },
});
</script>

<style scoped>
.app-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  font-size: var(--text-xs);
  font-weight: 600;
  border-left: 3px solid currentcolor;
  line-height: 1.4;
}

.badge-pill {
  border-left: none;
  border-radius: 12px;
  padding: 1px 8px;
}

.badge-outline {
  border: 1px solid currentcolor;
  border-left-width: 1px; /* Override default 3px */
  background: transparent;
}

.badge-accent {
  color: var(--clr-accent);
  background: var(--clr-accent-bg);
}
.badge-success {
  color: var(--clr-success);
  background: var(--clr-success-bg);
}
.badge-danger {
  color: var(--clr-danger);
  background: var(--clr-danger-bg);
}
.badge-warning {
  color: var(--clr-warning);
  background: var(--clr-warning-bg);
}
.badge-muted {
  color: var(--muted);
  background: var(--surface-raised);
}
.badge-on-call {
  color: var(--clr-on-call);
  background: var(--clr-on-call-bg);
}
.badge-travel {
  color: var(--clr-travel);
  background: var(--clr-travel-bg);
}
</style>
